import { gql } from '@utils/gpl-dedup';

export const notificationCreated = gql`
  subscription notificationCreated($user_id: ID!) {
    notificationCreated(
      user_id: $user_id
  ) {
      id
      title
      read
      message
      type
      ephemeral
      related_link
      related_link_title
      task {
        id
      },
      meta {
        export_filename
      },
    }
  }
`;
